"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonData = getCommonData;
const constants_1 = require("../../../utils/retryPolicy/constants");
const errors_1 = require("../../../utils/retryPolicy/errors");
const sleep_1 = require("../../../utils/sleep");
const requestsFactory_1 = require("./requestsFactory");
async function getCommonData(options, requestPayload, apisToSkip) {
    const { maxAttempts = constants_1.MAX_ATTEMPTS, minInterval = constants_1.MIN_INTERVAL, maxInterval = constants_1.MAX_INTERVAL, factor = constants_1.FACTOR, randomize = constants_1.RANDOMIZE, } = options;
    const requestByKey = (0, requestsFactory_1.requestsFactory)(requestPayload);
    const initialRequests = Object.entries(requestByKey).reduce((acc, [key, request]) => {
        if (apisToSkip && apisToSkip.has(key)) {
            return acc;
        }
        else {
            return [...acc, request];
        }
    }, []);
    let currentAttempt = 0;
    const result = {};
    async function makeRequests(requests) {
        const promises = requests.map((request) => request());
        const settledPromises = await Promise.allSettled(promises);
        const failedRequests = [];
        settledPromises.forEach((res) => {
            if (res.status === 'fulfilled') {
                if (res.value.error) {
                    failedRequests.push(requestByKey[res.value.entryKey]);
                }
                else {
                    result[res.value.entryKey] = res.value.data;
                }
            }
            else {
                throw new errors_1.UnhandledRequestError(res.reason);
            }
        });
        if (failedRequests.length) {
            if (currentAttempt >= maxAttempts) {
                throw new errors_1.MaxAttemptsError(maxAttempts);
            }
            let delay = Math.round(factor ** currentAttempt * minInterval);
            if (randomize) {
                delay = Math.round(Math.random() * 100 + delay);
            }
            delay = Math.min(delay, maxInterval);
            console.warn(`[${currentAttempt}] Need to retry. Next attempt in ${delay}`);
            await (0, sleep_1.sleep)(delay);
            currentAttempt += 1;
            await makeRequests(failedRequests);
        }
    }
    await makeRequests(initialRequests);
    return result;
}
//# sourceMappingURL=getCommonData.js.map